"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useIsFullScreen = function (fullScreen, isMobile) {
    var isFullScreen = (0, react_1.useMemo)(function () { return !!(fullScreen || isMobile); }, [fullScreen, isMobile]);
    return isFullScreen;
};
exports.default = useIsFullScreen;
